// extracted by mini-css-extract-plugin
module.exports = {"swiperSlide":"Slide_swiperSlide__1S6pA","row":"Slide_row__2Z2Ci","swiper-slide":"Slide_swiper-slide__3EC-U"};